// extracted by mini-css-extract-plugin
module.exports = {"avatar-wrapper":"aee5b7c44e--avatar-wrapper--ndqHK","type-name-container":"aee5b7c44e--type-name-container--deICC","type":"aee5b7c44e--type--cY7R7"};